"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.checkValidCPF = function (strCpf) {
  if (strCpf.length < 14) return false;
  var invalidsCPF = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
  var regex = /([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/;
  var sum = 0;
  var rest;
  if (!strCpf) return false;
  if (!strCpf.match(regex)) return false;
  strCpf = strCpf.replace(/\.|-/g, '');
  if (invalidsCPF.indexOf(strCpf) > -1) return false; //  Validates first digit

  for (var i = 0; i < 9; i++) {
    sum += parseInt(strCpf.charAt(i)) * (10 - i);
  }

  rest = 11 - sum % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(strCpf.charAt(9))) return false;
  sum = 0; //  Validates second digit

  for (var i = 0; i < 10; i++) {
    sum += parseInt(strCpf.charAt(i)) * (11 - i);
  }

  rest = 11 - sum % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(strCpf.charAt(10))) return false;
  return true;
};